import {mapGetters} from 'vuex';

const prakerjaPurchasedCourses = {
  data() {
    return {
      purchasedCourses: [],
    };
  },
  mounted() {
    if (this.isLogin) {
      this.getPurchasedCoupons();
    }
  },
  computed: {
    ...mapGetters(['getPurchasedVoucherToggle']),
    isLogin() {
      return window.USER.id !== '' && window.USER.id !== null;
    },
    isShow() {
      return this.isLogin && this.purchasedCourses.length > 0 && this.getPurchasedVoucherToggle;
    },
  },
  methods: {
    getPurchasedCoupons() {
      this.$api
        .getPrakerjaPurchasedCoupons()
        .then((response) => {
          this.purchasedCourses = response.data;
        })
        .catch(() => {
          this.purchasedCourses = [];
        });
    },
  },
};

export default prakerjaPurchasedCourses;
